import { Button, Col, Row, Select } from 'antd';
import Card from 'antd/es/card/Card';
import React, { useContext, useRef } from 'react';
import orderImage from '../../assets/images/orderImg.png';
import { FormButtons } from '../../commonComponents/buttons/button';
import { OrderContext } from '../../context/orderContext';
import { useCompanies, useListingCompanies } from '../../hooks/useCompanies';
import useLogout from '../../hooks/useLogout';
import arrowLeft from '../../../src/assets/images/arrowLeft.png';
import { useNavigate } from 'react-router-dom';

const CreateOrder = () => {
    const selectedCompany = useRef(null);
    const { details, address } = useContext(OrderContext);
    const [orderDetails, setOrderDetails] = details;
    const [companyAddress, setCompanyAddress] = address;
    const { logout } = useLogout();
    const navigate = useNavigate();

    const onSuccess = values => {
        // debugger;
        // console.log(values);
    };
    const transformation = data => {
        return data.map(item => {
            return {
                ...item,
                value: item.key,
                label: `${item.code} - ${item.name}`,
            };
        });
    };

    const { data: companiesList, isError } = useCompanies(onSuccess, transformation);

    const selectCompanyHandler = id => {
        let findCompany = companiesList.find(el => el.key == id);
        let tempData = {
            company: findCompany.key,
            companyCode: findCompany.code,
            clientName: findCompany.name,
        };
        //   "insurance": {
        //     "isInsured": false,
        //     "insuranceAmount": null,
        //     "insuranceCurrency": null
        // },
        selectedCompany.current = tempData;
        setCompanyAddress(findCompany.adresses);
    };
    if (isError) {
        logout();
    }
    return (
        <>
            <img
                src={arrowLeft}
                alt=""
                style={{
                    width: '30px',
                    cursor: 'pointer',
                    margin: '5px',
                    // padding: "10px",
                }}
                onClick={() => navigate(-1)}
            />
            <div className="addOrder-main w-100" style={{ marginTop: '60px' }}>
                <Card className="newOrder_card mx-auto" style={{ maxWidth: 550 }}>
                    <h3>Select a Client to Book a new Order</h3>
                    <img
                        style={{
                            maxWidth: '100%',
                            height: 'auto',
                            border: '1px solid #00000014',
                        }}
                        src={orderImage}
                        alt="orderImage"
                    />
                    <Select
                        className="mt-2"
                        placeholder="Select a company"
                        style={{
                            width: '100%',
                        }}
                        size="large"
                        showSearch
                        onChange={e => selectCompanyHandler(e)}
                        filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                        // value={props.orderDetails.company!= '' ? props.orderDetails.company:'Select a company'}
                        options={companiesList}
                    />

                    <FormButtons
                        onCancel={() => alert('cancelled')}
                        onConfirm={() => setOrderDetails({ ...orderDetails, ...selectedCompany.current })}
                    />
                </Card>
            </div>
        </>
    );
};

export default CreateOrder;
